import { useEffect } from 'react';
import { useT } from '@/shared/lib/i18n';

const MINI_APP_URL = import.meta.env.VITE_MINI_APP_URL as string | undefined;

export function TelegramRequiredScreen() {
  const t = useT();

  useEffect(() => {
    if (MINI_APP_URL) {
      window.location.replace(MINI_APP_URL);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#eef5ec] flex flex-col items-center justify-center p-8">
      <div className="glass-hero rounded-[24px] p-8 flex flex-col items-center gap-5 max-w-[320px] w-full text-center">
        <div className="w-16 h-16 bg-brand-gradient rounded-[20px] flex items-center justify-center">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-[19px] font-bold text-[#16271d]">{t('telegramRequired.title')}</p>
          <p className="text-[14px] text-[#6c7d70] leading-snug">
            {t('telegramRequired.text')}
          </p>
        </div>
        {MINI_APP_URL && (
          <a
            href={MINI_APP_URL}
            className="w-full rounded-full bg-brand-gradient text-white text-[15px] font-semibold py-3 px-6"
          >
            {t('telegramRequired.openButton')}
          </a>
        )}
      </div>
    </div>
  );
}
